import SEO from '../components/common/SEO'
import LeadershipExpertise from '../components/leadership/LeadershipExpertise'
import LeadershipPageCta from '../components/leadership/LeadershipPageCta'
import LeadershipPageHero from '../components/leadership/LeadershipPageHero'
import LeadershipPhilosophy from '../components/leadership/LeadershipPhilosophy'
import LeadershipTeamSection from '../components/leadership/LeadershipTeamSection'
import LeadershipVision from '../components/leadership/LeadershipVision'

function Leadership() {
  return (
    <>
      <SEO
        title="Leadership"
        description="Meet the leadership team of Torbit Metals Private Limited — directors with expertise in finance, international trade, procurement, compliance, operations and organizational management."
      />
      <LeadershipPageHero />
      {/* <LeadershipTeamSection /> */}
      <LeadershipVision />
      <LeadershipPhilosophy />
      <LeadershipExpertise />
      
      <LeadershipPageCta />
    </>
  )
}

export default Leadership
